/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = require('./src/uncompressed/TweenMax');



/*****************
 ** WEBPACK FOOTER
 ** ../vendors/gsap/index.js
 ** module id = 14
 ** module chunks = 0
 **/